import type { AuthUser } from '@entities/auth/model/types';

import type { UserInfoPayload } from '../model/types';

/**
 * Приводит payload `/user_info` к формату `AuthUser`, который хранится в сторе.
 *
 * @param payload Ответ backend с данными текущего пользователя.
 * @returns Нормализованный объект пользователя для auth-среза.
 */
export const mapUserInfoToAuthUser = (payload: UserInfoPayload): AuthUser => {
	const sipAor = payload.sip_aor.trim();
	const id = sipAor || 'user';
	const name = payload.display_name.trim() || id;

	return {
		id,
		name,
		sipAor: sipAor || undefined,
	};
};
